import React from 'react';
import { DateFilter } from '@energybox/react-ui-library/dist/components';
import {
  useViewportType,
  ViewportTypes,
} from '@energybox/react-ui-library/dist/hooks';
import SiteFilter from '../../../../components/Filters/SiteFilter';
import NotificationsTopNavigationBar from '../../../../components/TopNavigationBar/NotificationsTopNavigationBar';
import useAppLocale from '../../../../hooks/useAppLocale';
import { useTimeFilter } from '../../../../hooks/useFilters';
import tileStyles from '../../../../styles/tiles.module.css';
import {
  DailyNotificationsGraphTile,
  EquipmentTimeInIncidentStateTile,
  EquipmentWithMostIncidentsTile,
  IncidentsByPriorityTile,
  SitesWithMostIncidentsTile,
} from '../../../NotificationsOverviewTiles';
import styles from './NotificationsOverviewPage.module.css';

const NotificationsOverviewPage = () => {
  const isMobile = useViewportType() === ViewportTypes.MOBILE;
  const locale = useAppLocale();
  const { timePeriod, setTimeFilter } = useTimeFilter();

  return (
    <div>
      <NotificationsTopNavigationBar path="overview" />

      <div className={styles.pageContainer}>
        <div className={styles.row}>
          <DateFilter
            useCurrentTime
            value={timePeriod}
            setFilter={setTimeFilter}
            customPickerVariant={'date'}
            alignItemsRight={isMobile}
            locale={locale}
          />
          <SiteFilter
            className={styles.siteFilter}
            dropdownClassName={styles.siteFilterDropdown}
            alignItemsRight={isMobile}
          />
        </div>

        <div
          className={`${tileStyles.tilesContainer} ${styles.verticalPadding}`}
        >
          {/* All commented out tiles are archived, will need significant refactoring
          to fit into new tileStyles if we were to reintroduce them.
          Some of them don't make sense anymore b/c this page now has dynamic timeRange */}

          {/* <TodaysNotifications
            isLoading={isNotificationLoading}
            notifications={notifications}
            onClickTodaysNotifications={onClickTodaysNotifications}
          />

          <CriticalNotifications
            isLoading={isNotificationLoading}
            notifications={notifications}
            onClickCriticalNotifications={onClickCriticalNotifications}
          />

          <OldUnseenNotifications
            isLoading={isNotificationLoading}
            notifications={notifications}
            onClickOldUnseenNotifications={onClickOldUnseenNotifications}
          />

          <SitesConnectivity isLoading={isSiteLoading} sites={sites} />

          <InstalledSites
            isLoading={isSiteLoading}
            sites={sites}
            onClickSites={onClickSites}
          /> */}

          {/* archive this new tile for now, will need redesign, per Harsh */}
          {/* <IncidentSummaryTile
            className={tileStyles.singleTile}
            timePeriod={timePeriod}
          /> */}

          <SitesWithMostIncidentsTile
            className={tileStyles.singleTile}
            timePeriod={timePeriod}
          />

          <DailyNotificationsGraphTile
            className={tileStyles.doubleTile}
            timePeriod={timePeriod}
          />

          <EquipmentWithMostIncidentsTile
            className={tileStyles.singleTile}
            timePeriod={timePeriod}
          />

          <EquipmentTimeInIncidentStateTile
            className={tileStyles.singleTile}
            timePeriod={timePeriod}
          />

          <IncidentsByPriorityTile
            className={tileStyles.singleTile}
            timePeriod={timePeriod}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationsOverviewPage;
